import React from "react";
import { RouteComponentProps } from "react-router-dom";
import { usePageTypeContent } from "../../hooks/UseContentHook";
import { VectorEquipmentFaultsPage, VectorEquipmentFaultsPageProps } from "./VectorEquipmentFaultsPage";

export const EMPTY_PAGE_CONTENT: VectorEquipmentFaultsPageProps = {
  pageTitle: "",
};

export const CANONICAL_LINK = "/personal/outages-faults/vector-equipment";

export const VectorEquipmentFaultsPageContainer: React.FC<RouteComponentProps> = routeProps => {
  const { content } = usePageTypeContent<VectorEquipmentFaultsPageProps>("vector_equipment_faults", EMPTY_PAGE_CONTENT);
  if (content.seo) {
    content.seo.canonicalLink = CANONICAL_LINK;
  }
  return <VectorEquipmentFaultsPage {...routeProps} {...content} />;
};
